function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
import { retrieveConvergentBillerSubscriberSummaryPromise } from '../../../../reducers/actions/customer.convergent.biller.actions';
export var UPDATE_SERVICE_FRIENDLY_NAME = {
  BEGIN: 'UPDATE_SERVICE_FRIENDLY_NAME.BEGIN',
  SUCCESS: 'UPDATE_SERVICE_FRIENDLY_NAME.SUCCESS',
  FAILURE: 'UPDATE_SERVICE_FRIENDLY_NAME.FAILURE'
};
var UPDATE_SERVICE_FRIENDLY_NAME_CONSTANTS = [UPDATE_SERVICE_FRIENDLY_NAME.BEGIN, UPDATE_SERVICE_FRIENDLY_NAME.SUCCESS, UPDATE_SERVICE_FRIENDLY_NAME.FAILURE];
export var updateServiceFriendlyNamePromise = function updateServiceFriendlyNamePromise(dispatch, customerId, serviceId, friendlyName) {
  return ThunkHelper(dispatch, UPDATE_SERVICE_FRIENDLY_NAME_CONSTANTS, {
    method: 'post',
    url: 'SubscriberManagement/UpdateSubscriberServiceFriendlyName',
    data: {
      FriendlyName: friendlyName,
      ServiceIdentifier: serviceId
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var updateServiceFriendlyName = function updateServiceFriendlyName(customerId, serviceIdentifier, friendlyName) {
  return function (dispatch) {
    return updateServiceFriendlyNamePromise(dispatch, customerId, serviceIdentifier, friendlyName).then(function () {
      return retrieveConvergentBillerSubscriberSummaryPromise(dispatch, customerId);
    });
  };
};
export var subscriberProductExpirationRenewOptInOutPromise = function subscriberProductExpirationRenewOptInOutPromise(dispatch, customerId, productId, optIn, reasonCode) {
  return ThunkHelper(dispatch, UPDATE_SERVICE_FRIENDLY_NAME_CONSTANTS, {
    data: !optIn ? {
      SubscriberProductIds: [productId],
      OptOutReasonCode: reasonCode
    } : {
      SubscriberProductIds: [productId]
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    method: 'post',
    url: optIn ? 'SubscriberManagement/SubscriberProductExpirationRenewOptIn' : 'SubscriberManagement/SubscriberProductExpirationRenewOptOut'
  });
};
export var subscriberProductExpirationRenewOptInOut = function subscriberProductExpirationRenewOptInOut(customerId, productId) {
  var optIn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var reasonCode = arguments.length > 3 ? arguments[3] : undefined;
  return function (dispatch) {
    return subscriberProductExpirationRenewOptInOutPromise(dispatch, customerId, productId, optIn, reasonCode).then(function () {
      return retrieveConvergentBillerSubscriberSummaryPromise(dispatch, customerId);
    });
  };
};